// import { atom } from 'jotai';
import { atomWithHash } from '@/atoms/atomWithHash';
import { atom } from 'jotai';

export const selectedReviewMemberAtom = atomWithHash<string | undefined>(
  'reviewMember',
  undefined,
  {
    setHash: 'replaceState',
  }
);
export const isInviteModalV2OpenAtom = atom<boolean>(false);
